__turbopack_context__.v({
  "userProfileDrawer": "fjy7OG_userProfileDrawer",
  "userProfileDrawer__detail": "fjy7OG_userProfileDrawer__detail",
  "userProfileDrawer__details": "fjy7OG_userProfileDrawer__details",
  "userProfileDrawer__empty": "fjy7OG_userProfileDrawer__empty",
  "userProfileDrawer__footer": "fjy7OG_userProfileDrawer__footer",
  "userProfileDrawer__footerWrap": "fjy7OG_userProfileDrawer__footerWrap",
  "userProfileDrawer__header": "fjy7OG_userProfileDrawer__header",
  "userProfileDrawer__identity": "fjy7OG_userProfileDrawer__identity",
  "userProfileDrawer__identityText": "fjy7OG_userProfileDrawer__identityText",
  "userProfileDrawer__section": "fjy7OG_userProfileDrawer__section",
});
